import GetCycles from 'src/api/Cycle/GetCycles'

class GetCycleById extends GetCycles {
  requestUrl = `/api/Cycle/${this.getParams().id}`
}

export default GetCycleById
